import { EdgeSwipeBack, EdgeSwipeBackLayer, isEnabledSwipeBack } from '@web/components/edge-swipe-back'
import { PhoneFrame } from '@web/components/phone-frame'
import { RouteTransitionOutlet } from '@web/router/transition/outlet'
import { SheetHost } from '@web/sheets'
import { ScrollRestoration } from 'react-router-dom'

export function PhoneFrameLayout() {
  return (
    <PhoneFrame>
      {document.documentElement.hasAttribute('data-ios-browser') && <ScrollRestoration />}
      {isEnabledSwipeBack() && <EdgeSwipeBack />}
      <EdgeSwipeBackLayer>
        <RouteTransitionOutlet />
      </EdgeSwipeBackLayer>
      <SheetHost />
    </PhoneFrame>
  )
}
